import { useWhatsappTelefone } from '@/hooks/useWhatsappTelefone';
import { cn } from '@/lib/utils';

const LOGO = 'M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38a9.9 9.9 0 0 0 4.74 1.21h.01c5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.82 9.82 0 0 0 12.04 2zm5.8 14.09c-.24.68-1.42 1.3-1.95 1.34-.5.05-.97.24-3.27-.68-2.77-1.09-4.52-3.93-4.66-4.11-.13-.18-1.11-1.48-1.11-2.82 0-1.34.7-2 .95-2.27.25-.27.54-.34.72-.34h.52c.16 0 .39-.06.61.47.24.55.77 1.9.84 2.04.07.14.11.3.02.48-.09.18-.14.3-.27.46-.14.16-.29.36-.41.48-.14.14-.28.29-.12.56.16.27.71 1.18 1.53 1.91 1.05.94 1.94 1.23 2.21 1.37.27.14.43.11.59-.07.16-.18.68-.79.86-1.07.18-.27.36-.23.61-.14.25.09 1.59.75 1.86.89.27.14.45.2.52.32.07.11.07.66-.17 1.33z';

/** Selo do WhatsApp ao lado do telefone: verde = tem; apagado = não tem. */
export function WhatsappBadge({ telefone, className }: { telefone?: string | null; className?: string }) {
  const { data } = useWhatsappTelefone(telefone);
  if (!data || data.tem_whatsapp === null) return null;
  const quando = data.consultado_em ? new Date(data.consultado_em).toLocaleDateString('pt-BR') : '';
  return (
    <span
      title={data.tem_whatsapp ? `Tem WhatsApp · consultado em ${quando}` : `Sem WhatsApp · consultado em ${quando}`}
      className={cn('inline-flex flex-shrink-0 items-center', className)}
    >
      <svg viewBox="0 0 24 24" className="h-3.5 w-3.5" aria-label={data.tem_whatsapp ? 'Tem WhatsApp' : 'Sem WhatsApp'}>
        <path d={LOGO} className={data.tem_whatsapp ? 'fill-[#25D366]' : 'fill-muted-foreground/40'} />
      </svg>
    </span>
  );
}
